// @flow
import $ from 'jquery';
import JQueryView, {
  on,
  removeInvalidFeedback,
} from '../../../common/JQueryView';
import maskInput from '../../../../utils/maskInput';
import DateRangePicker from '../../../common/DateRangePicker';
import dayjs from 'dayjs';
import SearchAddressForm from '../../../common/SearchAddressForm';

export default class ShowView extends JQueryView {
  cloneFileElement = {};
  errorMessage: string;
  searchAddress: Object;

  constructor(errorMessage: string) {
    super('.simple_form');
    this.errorMessage = errorMessage;
    if (errorMessage) {
      this.editCompany(errorMessage);
    }
    this.searchAddress = new SearchAddressForm('.simple_form');

    $('.form-group-float').each((index, element) => {
      const control = $(element).find('.form-control');
      if (control.val().length !== 0) {
        control.addClass('form-control-active');
      } else {
        control.removeClass('form-control-active');
      }
    });

    this.render();
  }

  initDateRangePicker(container: any) {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        timePicker: false,
        timePicker24Hour: false,
        showDropdowns: true,
        maxDate: dayjs(),
        locale: {
          format: 'YYYY/MM/DD',
        },
      },
      {
        picker: {
          format: {
            start: 'YYYY/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  }

  editCompany(element: string) {
    const allButtons = [
      'name-edit-button',
      'kana_name-edit-button',
      'size-edit-button',
      'establish-edit-button',
      'closing-edit-button',
      'representative-edit-button',
      'address-edit-button',
      'website-edit-button',
      'phone_number-edit-button',
      'image-edit-button',
    ];
    const allData = [
      'name_data',
      'kana_name_data',
      'size_data',
      'establish_data',
      'closing_data',
      'representative_data',
      'address_data',
      'website_data',
      'phone_number_data',
    ];
    const allForms = [
      'company_name',
      'company_kana_name',
      'company_company_size',
      'company_establish_at',
      'company_closing_month',
      'company_representative',
      'company_zip_code',
      'company_prefecture',
      'company_city',
      'company_address',
      'company_website',
      'company_phone_number',
    ];
    const aboutAddress = ['zip_code', 'prefecture', 'city'];
    element = aboutAddress.includes(element) ? 'address' : element;
    let reg = new RegExp(element);
    const otherButtons = allButtons.filter(
      e => !(e === `${element}-edit-button`),
    );

    const hideData = allData.find(e => e.match(reg));
    let otherForms = [];
    if (element == 'address') {
      otherForms = allForms.filter(
        e => !e.match('(zip_code)|(prefecture)|(city)|(address)'),
      );
    } else {
      otherForms = allForms.filter(e => !e.match(reg));
    }

    if (hideData) {
      $(`.${hideData}`).toggle();
    }

    $(`.${element}-form`).toggle();

    if ($(`.${element}-edit-button`).text() == '編集') {
      $(`.${element}-edit-button`).text('キャンセル');
      otherButtons.forEach(e =>
        $(`.${e}`).addClass('company-edit-button-disable'),
      );
      otherForms.forEach(e => $(`#${e}`).prop('disabled', true));
    } else {
      $(`.${element}-edit-button`).text('編集');
      otherButtons.forEach(e =>
        $(`.${e}`).removeClass('company-edit-button-disable'),
      );
      if (location.pathname == '/company/settings/basic') {
        window.location.replace('/company/settings/basic');
      } else if (
        location.pathname.includes('/company/matching/settings/company')
      ) {
        window.location.replace('/company/matching/settings/company/edit');
      } else if (location.pathname == '/vc/settings/basic') {
        window.location.replace('/vc/settings/basic');
      }
    }
  }

  @on({ event: 'click', selector: '.name-edit-button' })
  editCompanyName() {
    this.editCompany('name');
  }

  @on({ event: 'click', selector: '.kana_name-edit-button' })
  editCompanyKana() {
    this.editCompany('kana_name');
  }

  @on({ event: 'click', selector: '.size-edit-button' })
  editCompanySize() {
    this.editCompany('size');
  }

  @on({ event: 'click', selector: '.establish-edit-button' })
  editCompanyEstablish() {
    this.editCompany('establish');
  }

  @on({ event: 'click', selector: '.closing-edit-button' })
  editCompanyClosing() {
    this.editCompany('closing');
  }

  @on({ event: 'click', selector: '.representative-edit-button' })
  editCompanyRepresentative() {
    this.editCompany('representative');
  }

  @on({ event: 'click', selector: '.address-edit-button' })
  editCompanyAddress() {
    this.editCompany('address');
  }

  @on({ event: 'click', selector: '.website-edit-button' })
  editCompanyWebsite() {
    this.editCompany('website');
  }

  @on({ event: 'click', selector: '.phone_number-edit-button' })
  editCompanyPhone() {
    this.editCompany('phone_number');
  }

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.find('.form-control').addClass('form-control-active');
    }
  }

  @on({ event: 'blur input', selector: '.form-group-float, .form-control' })
  onBlurFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length === 0) {
      target.removeClass('form-control-active');
    } else {
      target.addClass('form-control-active');
      target.removeClass('is-invalid');
      removeInvalidFeedback(target);
    }
  }

  render() {
    this.initDateRangePicker(this.$el);
    maskInput();
  }
}
